import { Component, inject } from '@angular/core';
import { IcSettingsService } from '@item-cache';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'di-segment-error',
  templateUrl: './segment-error.component.html',
  styleUrl: './segment-error.component.scss',
})
export class SegmentErrorComponent {
  protected readonly errorMessageSignal = inject(IcSettingsService).segmentErrorSignal;

  backToHome() {
    window.location.href = environment.vismaHomeUrl;
  }
}
